import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService, DialogService, SnackbarService } from '../../../services';

@Component({
  selector: 'prism-cancel-policy',
  templateUrl: './cancel-policy.component.html',
  styleUrls: ['./cancel-policy.component.scss']
})
export class CancelPolicyComponent implements OnInit {

  constructor(private dialogService: DialogService,
              private authService: AuthenticationService,
              private snackbarService: SnackbarService) {
  }

  ngOnInit() {
  }

  confirmAndLogout() {
    this.dialogService.closeDialog();
    this.authService.logout()
      .then()
      .catch(() => {
        this.snackbarService.handleError(`Error logging out. Please try again`);
      });
  }

  cancelAndStay() {
    this.dialogService.closeDialog();
  }
}
